// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"177":"home","328":"admin","571":"settings","821":"inspection"}[chunkId] || chunkId) + "." + {"82":"295ef524","177":"40b832da","328":"53a636ae","571":"25a6aea3","821":"03814f49"}[chunkId] + ".css";
};